import React from 'react';
import {Box, Typography, Paper, Stack, Divider, Link, Button, IconButton, Avatar} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearAllIcon from '@mui/icons-material/ClearAll';

// A simple helper function to check if the string is a valid web URL.
const isValidUrl = (string) => {
    if (!string) return false;
    return string.startsWith('http://') || string.startsWith('https://');
};

const MachineQueueCard = ({
                              machineId,
                              machineName,
                              categoryImageUrl,
                              players = [], // Default to an empty array to handle empty queues
                              displayMode = 'full', // 'full' or 'compact'
                              onClearQueue,
                              onRemovePosition,
                              isActionLoading = false,
                          }) => {

    const renderHeader = () => {
        if (displayMode === 'full') {
            return (
                <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{mb: 1.5}}>
                    <Stack direction="row" alignItems="center" spacing={1.5} overflow="hidden">
                        <Avatar src={categoryImageUrl}/>
                        <Box>
                            <Typography variant="h6">{machineName}</Typography>
                            <Link component={RouterLink} to={`/machines/${machineId}`}
                                  sx={{fontFamily: 'monospace', fontSize: '0.8rem'}}>
                                {machineId}
                            </Link>
                        </Box>
                    </Stack>
                    <Button size="small" variant="outlined" color="error" startIcon={<ClearAllIcon/>}
                            onClick={() => onClearQueue(machineId)} disabled={isActionLoading}>
                        Clear
                    </Button>
                </Stack>
            );
        } else {
            return (
                    <Typography variant="h6" gutterBottom>Live Queue</Typography>


            )
        }
    };

    return (
        <Paper elevation={2} sx={{p: 2, height: '100%'}}>
            {renderHeader()}

            <Divider sx={{mb: 2}}/>
            <Stack spacing={1}>
                {players.length > 0 ? (
                    players.map((player, index) => {
                        const hasValidAvatar = isValidUrl(player.playerAvatarUrl);
                        return (
                            <Paper key={player.id} variant="outlined" sx={{p: 1.5}}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center">
                                    <Stack direction="row" alignItems="center" spacing={1.5}>
                                        <Typography variant="h6"
                                                    sx={{color: 'text.secondary'}}>#{index + 1}</Typography>
                                        <Avatar src={hasValidAvatar ? player.playerAvatarUrl : undefined}
                                                sx={{width: 24, height: 24}}>
                                            {!hasValidAvatar && player.playerName ? player.playerName.charAt(0).toUpperCase() : null}
                                        </Avatar>
                                        <Link component={RouterLink} to={`/players/${player.playerUid}`}
                                              sx={{fontWeight: 'bold'}}>
                                            {player.playerName || player.playerUid}
                                        </Link>
                                    </Stack>
                                    {!!onRemovePosition && (
                                        <IconButton edge="end" color="error"
                                                    onClick={() => onRemovePosition(machineId, player)}
                                                    disabled={isActionLoading}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    )}
                                </Stack>
                            </Paper>
                        )
                    })
                ) : (
                    <Typography sx={{textAlign: 'center', color: 'text.secondary', p: 2}}>
                        The queue is empty.
                    </Typography>
                )}
            </Stack>
        </Paper>
    );
};

export default MachineQueueCard;